import React from 'react';
import { observer } from 'mobx-react';
import RatingIndex from 'pages/builder/ratings/rating_index';
import BackEndExplainer from 'pages/creator/back_end_explainer';
import { AppUI } from '@seedlang/state';
import PageTitle from 'components/common/page_title';

@observer
class ExerciseRatingsIndex extends React.Component {

  render() {
    return (
      <div>
        <PageTitle>Exercise Ratings</PageTitle>
        <BackEndExplainer margin='10px 0'>
          <div>These are the ratings and comments left by users after they have completed an exercise.</div>
        </BackEndExplainer>
        <RatingIndex
          simple
          showExercise
          groupId={AppUI.groupId}
          defaultFilters={{group_id: AppUI.groupId, comment: true}}
        />
      </div>
    );
  }
}

export default ExerciseRatingsIndex;
